<template>
  <slot />

  <div
    v-bind="$attrs"
    class="flex flex-col justify-center items-center h-full bg-neutral-primary m-2 rounded-md"
  >
    <Image src="error" alt="error" />

    <NText weight="bold" variant="caption1" class="py-4">
      {{ t('common.noInformationReceived') }}
    </NText>

    <NButton variant="flat" size="small" color="gray" @click="emit('retry')">
      <NText weight="bold" variant="caption1" class="px-6">
        {{ t('misc.retry') }}
      </NText>
    </NButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import Image from '@/components/Image.vue';

const emit = defineEmits<{ (e: 'retry'): void }>();

const { t } = useI18n();
</script>
